import Carousel from './carousel';

document.addEventListener('DOMContentLoaded', () => {
	const carousels = [...document.querySelectorAll('.carousel')];
	if (carousels.length) {
		carousels.forEach((node) => new Carousel(node));
	}
});



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_slider/script.js